(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-offers"] && !window.DesignMode) return;
  try {
    
  // Weightless ReCharge override
  function weightlessOrderScheduleOverride(productId) {
    poll(() => {
      return document.querySelector(`#selling_plan_${productId}`);
    }, 1000, 100).then(() => {
      const productOrderSchedule = document.querySelector(`#selling_plan_${productId}`);
      const options = Array.from(productOrderSchedule.options);
      const newOption = options.find(o => o.dataset.planOption === "Delivery Every 2 Months");

      if (newOption) { 
        productOrderSchedule.value = newOption.value;
      }
    }).catch((e) => {
      console.log("Weightless override for product failed: " + productId);
    });    
  }

  const rechargeTimeout = 60 * 1000;
  const rechargePollRate = 100;
  
  // Bind the on click events
  function handleQuantityUpdate(e) {    
    const el = e.target;
    const parent = el.parentNode;
    const input = parent.querySelector("input");
    const qty = parseInt(el.dataset.qty) || 1;
    const current = parseInt(input.value)
    if (!current) {
      input.value = qty;
    } else {
      input.value = parseInt(input.value) + qty;
    }
  }

  function handleVariantChange(e) {
    const el = e.target;
    
    // Selectors
    const form = document.getElementById(el.dataset.form);
    const variantJSON = form.querySelector('[type="application/json"]');
    const priceEl = form.querySelector("[data-product-price]");
    const compareAtPriceEl = form.querySelector("[data-product-compare-at-price]");
    const currentVariant = parseInt(el.value);
    
    const variantData = JSON.parse(variantJSON.textContent);
    const variant = variantData.find(v => v.id === currentVariant);

    // update variant pricing.
    priceEl.textContent = "$" + variant.price / 100;
    compareAtPriceEl.textContent = "$" + variant.compare_at_price / 100;
  }

  const variantSelects = document.querySelectorAll(".product-offer__variants select");
  for (const select of variantSelects) {
    select.addEventListener("change", handleVariantChange);
  }
  
  const quantityButtons = document.querySelectorAll(".product-offer__qty-button");
  for (const btn of quantityButtons) {
    btn.addEventListener("click", handleQuantityUpdate);  
  }

  function poll(fn, timeout, interval) {
    const endTime = Number(new Date()) + (timeout || 2000);
    interval = interval || 100;

    const checkCondition = function(resolve, reject) {
      // If the condition is met, we're done.
      const result = fn();
      if (result) {
        resolve(result);
      } else if (Number(new Date()) < endTime) {
        setTimeout(checkCondition, interval, resolve, reject);
      } else {
        reject(new Error("timed out for" + fn + ": " +arguments));
      }
    };

    return new Promise(checkCondition);
  }

  function initRechargeProducts() {
    // Find all the recharge containers.
    const rechargeContainers = document.querySelectorAll("[data-enable-recharge]");
    const configs = [];
    for (let el of Array.from(rechargeContainers)) {
      const productId = el.dataset.productId;
      configs.push({
        productId: parseInt(productId),
        injectionParent: '.rc-widget-injection-parent-' + productId
      });
    }
    
  
    // if there are configs, start poll for recharge.
    if (configs.length > 0) {
      poll(() => {
        return window.ReChargeWidget !== undefined;
      }, rechargeTimeout, rechargePollRate).then(() => {
        // Initialize recharge widgets.
        window.ReChargeWidget.createWidgets(configs);
        
        // Weightless custom hook
        for (let el of Array.from(rechargeContainers)) {
          const productId = el.dataset.productId;
          weightlessOrderScheduleOverride(productId);
        }
      }).catch((e) => {
        console.log("ReCharge timed out.");
      });  
    }
  }

  initRechargeProducts();
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

})();
